import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';

import { LanguageService } from "@spotter/services/internal/language-service";
import { AuthService } from '@spotter/services/user/auth-service';
import { UserService } from '@spotter/services/user/user-service';
import { ExploreService } from '@spotter/services/sightings/explore-service';
import { EventService } from '@spotter/services/internal/event-service';


import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';


import { SidebarLayout } from '@spottercomponents/layout/sidebar/sidebar.component';
import { sidebarLayout } from './app-sidebar-layout';
import { ToastService } from '@spotter/services/internal/toast-service';
import { MainLayoutComponent } from '@spotter/components/layout/main-layout/main-layout.component';
//import { FilterComponent } from './partials/filter/filter.component';
import { FaConfig, FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FilterComponent } from './pages/sightings/_partials/filter/filter.component';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet></router-outlet>
        <ng-template #filterCanvas let-offcanvas>
            <filter></filter>
        </ng-template>
    `,
    styleUrls: ['./app.scss'],
    imports: [RouterOutlet, FontAwesomeModule, FilterComponent],
})
export class App {
    title = 'spotter-site';

    @ViewChild('filterCanvas', { read: TemplateRef }) filterCanvas!: TemplateRef<any>;

    sidebarLayout: SidebarLayout = sidebarLayout;

    constructor(public languageSevice: LanguageService,
        public translate: TranslateService,
        public auth: AuthService,
        public router: Router,
        private explore: ExploreService, public events: EventService, public toastService: ToastService, public userService: UserService, private offcanvasService: NgbOffcanvas, library: FaIconLibrary, faConfig: FaConfig) {

        library.addIconPacks(fas, fab);        // register packs
        faConfig.fixedWidth = true;
        faConfig.defaultPrefix = 'fas';        // optional: lets <fa-icon icon="map"> work

        this.explore.getAbsences().subscribe(); // Trigger so it feels snappier when navigating over


        // Show or hide the filter popover
        this.events.showFilter.subscribe((shouldShow: boolean) => {
            if (shouldShow)
                this.offcanvasService.open(this.filterCanvas, { position: (this.languageSevice.language.dir == "rtl") ? 'start' : "end", panelClass: 'filter-panel', container: '.main-section' });
            else
                this.offcanvasService.dismiss();
        })

    }
}
